import { useModel } from '@umijs/max';
import { useSafeState } from 'ahooks';
import { CommunityInfoType } from '@/pages/Home/interface';
import { queryWechatBindCommunity } from '@/pages/Home/service';

export default function useCommunity() {
  const { openId } = useModel('useGlobal', (model) => ({
    openId: model.openId,
  }));

  const [communityInfo, setCommunityInfo] = useSafeState<CommunityInfoType[]>(
    [],
  );
  const [defaultCommunity, setDefaultCommunity] =
    useSafeState<CommunityInfoType>();

  const handleQueryBindCommunity = async () => {
    const { code, data } = await queryWechatBindCommunity(openId!);
    if (code === 200) {
      setCommunityInfo(data!);
      setDefaultCommunity((data || []).find((item) => item.isDefault === 1)!);
    }
  };

  // useUpdateEffect(() => {
  //   if (openId !== undefined) {
  //     handleQueryBindCommunity();
  //   }
  // }, [openId]);

  return {
    communityInfo,
    handleQueryBindCommunity,
    defaultCommunity,
  };
}
